import { createStore } from "vuex"
import admin from "./modules/admin"
import client from "./modules/client"
import contact from "./modules/contact"
import contactEmprendimiento from "./modules/contactEmprendimiento"
import user from "./modules/user"
import noticias from "./modules/noticias"
import files from "./modules/files"
import estadisticas from "./modules/estadisticas"

const API_BASE = process.env.VUE_APP_API_BASE;
const API_USUARIOS = `${API_BASE}/ajax/usuarios.php`;

export default createStore({
  modules: {
    admin,
    client,
    contact,
    contactEmprendimiento,
    user,
    noticias,
    files,
    estadisticas,
  },
  
  state: {
    services: [
      {
        title: "Auditoría",
        description:
          "Servicios de previsión y control interno y externo para garantizar la integridad y correcta exposición de sus operaciones contables.",
        route: "/servicios/auditoria",
      },
      {
        title: "Impuestos",
        description:
          "Planificación y cumplimiento fiscal para optimizar la carga impositiva y aprovechar los beneficios fiscales vigentes.",
        route: "/servicios/impuestos", 
      },
      {
        title: "Laboral",
        description:
          "Gestión integral de las relaciones laborales, desde la liquidación de sueldos hasta el asesoramiento estratégico en contratación.",
        route: "/servicios/laboral",
      },
      {
        title: "Gestión Empresarial",
        description:
          "Definición de visión, estrategias y planes de acción para alinear todas las áreas de su negocio hacia objetivos claros.",
        route: "/servicios/gestion",
      },
      {
        title: "Interim Management",
        description:
          "Incorporación temporal de directivos senior para liderar proyectos específicos y resolver desafíos complejos sin incrementar costos fijos.",
        route: "/servicios/auditoria",
      },
    ],
    articles: [
      {
        title: "Claves para la Planificación Fiscal 2026",
        category: "FINANZAS",
        image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=2670&auto=format&fit=crop",
      },
      {
        title: "El rol del Interim Manager en la transformación digital",
        category: "GESTIÓN",
        image: "https://images.unsplash.com/photo-1516321497487-e288fb19713f?q=80&w=2670&auto=format&fit=crop",
      },
      {
        title: "Nuevas regulaciones laborales: ¿Cómo impactan?",
        category: "MERCADOS",
        image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=2832&auto=format&fit=crop",
      },
      {
        title: "Estrategias para la retención de talento",
        category: "RRHH",
        image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=2670&auto=format&fit=crop",
      },
      {
        title: "Fideicomisos: una herramienta de planificación",
        category: "LEGAL",
        image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=2670&auto=format&fit=crop",
      },
      {
        title: "Cómo tomar mejores decisiones en su PyME",
        category: "ESTRATEGIA",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2670&auto=format&fit=crop",
      },
    ],
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    currentUser: (state) => state.user,
    userRole: (state) => state.userRole,
    isAdmin: (state) => state.userRole === "admin",
    isClient: (state) => state.userRole === "user",
    getServices: (state) => state.services,
    getArticles: (state) => state.articles,
    getServiceByTitle: (state) => (title) => {
      return state.services.find((service) => service.title === title)
    },
    getArticlesByCategory: (state) => (category) => {
      return state.articles.filter((article) => article.category === category)
    },
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      state.isAuthenticated = true
      state.userRole = user.role
      localStorage.setItem("user", JSON.stringify(user))
    },
    LOGOUT(state) {
      state.user = null
      state.isAuthenticated = false
      state.userRole = null
      localStorage.removeItem("user")
    },
    RESTORE_SESSION(state) {
      const user = localStorage.getItem("user")
      if (user) {
        const userData = JSON.parse(user)
        state.user = userData
        state.isAuthenticated = true
        state.userRole = userData.role
      }
    },
    SET_SERVICES(state, services) {
      state.services = services
    },
    SET_ARTICLES(state, articles) {
      state.articles = articles
    },
    ADD_SERVICE(state, service) {
      state.services.push(service)
    },
    ADD_ARTICLE(state, article) {
      state.articles.push(article)
    },
  },
  actions: {
    async login({ commit, dispatch }, credentials) {
      await dispatch("files/cancelRequests")
      commit("files/CLEAR_FILES")

      try {
        const response = await fetch(`${API_BASE}/ajax/usuarios.php?action=login`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(credentials),
        })

        const data = await response.json()

        if (data.success) {
          const userData = {
            id: data.user.id_usuario,
            cuit: data.user.cuit,
            email: data.user.mail,
            role: data.rol,
            roleId: data.user.id_role,
          }

          console.log("[v0] Login successful, user role:", userData.role)
          commit("SET_USER", userData)
          return { success: true, role: userData.role }
        } else {
          console.log("[v0] Login failed:", data.message)
          return { success: false, message: data.message || "Error de autenticación" }
        }
      } catch (error) {
        console.error("Login error:", error)
        return { success: false, message: "Error de conexión" }
      }
    },
    async logout({ commit, dispatch }) {
      await dispatch("files/cancelRequests")
      try {
        const response = await fetch(`${API_USUARIOS}?action=logout`, {
          method: "POST",
          credentials: "include",
          cache: "no-store",
        })

        const data = await response.json()
        return {
          success: response.ok && data.success,
          message: data.message,
        }
      } catch (error) {
        console.error("Logout error:", error)
        return { success: false, message: "No se pudo cerrar la sesión en el servidor" }
      } finally {
        commit("LOGOUT")
        commit("files/CLEAR_FILES")
      }
    },
    restoreSession({ commit }) {
      commit("RESTORE_SESSION")
    },
    async validateSession({ commit, dispatch }) {
      try {
        const response = await fetch(`${API_USUARIOS}?action=session`, {
          credentials: "include",
          cache: "no-store",
        })
        const data = await response.json()

        if (!response.ok || !data.success || !data.authenticated) {
          commit("LOGOUT")
          await dispatch("files/cancelRequests")
          commit("files/CLEAR_FILES")
          return { success: false, status: response.status }
        }

        const userData = {
          id: data.user.id_usuario,
          cuit: data.user.cuit,
          email: data.user.mail,
          role: data.rol,
          roleId: data.user.id_role,
        }
        commit("SET_USER", userData)
        return { success: true, role: userData.role }
      } catch (error) {
        commit("LOGOUT")
        await dispatch("files/cancelRequests")
        commit("files/CLEAR_FILES")
        return { success: false, message: "No se pudo validar la sesion" }
      }
    },
    updateServices({ commit }, services) {
      commit("SET_SERVICES", services)
    },
    updateArticles({ commit }, articles) {
      commit("SET_ARTICLES", articles)
    },
    addService({ commit }, service) {
      commit("ADD_SERVICE", service)
    },
    addArticle({ commit }, article) {
      commit("ADD_ARTICLE", article)
    },
  },
})
